import React from "react";


function Timing() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/bg.jpg)',backgroundSize:'cover',backgroundPosition:'center'}}>
      </div>
      <div className="" style={{backgroundImage:'url(./images/event.jpeg)',padding:'10px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}}>
            <div className="col-md-5" style={{backgroundImage:'url(./images/japam.jpg)',height:'100vh',backgroundSize:'cover',backgroundPosition:'center',padding:'50px'}}>
                
            </div>
            <div className="col-md-7" style={{background:'#ffeccaf6',padding:'50px',height:'100vh'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 ">
                       <center><p className="enquiry">AKHANDA NAMA JAPAM</p> </center>                                         
                    </div>
                </div>
                <div className="row" style={{marginBottom:'50px',paddingBottom:'15px',paddingTop:'15px'}}>
                    <center>
                          <h3 className="theading" style={{fontSize:'20px',fontWeight:'600',marginTop:'-20px',textAlign:'center'}}>The incessant flow of energy:-</h3>
                      </center>
                        <p style={{fontSize:'12pt',color:'black',textAlign:'justify',paddingTop:'25px'}}>
                            On 24th February, 1955, Swamiji lit an Akhanda Deepam from the flame that he lit and brought from the Samadhi Temple of Sri. Chattambi Swamigal, at Panmana, Quilon, Kerala. He started ‘Akhanda Nama Japa chanting the Mahamanthram Hare Rama Hare Rama Rama Rama Hare Hare Hare Krishna Hare Krishna Krishna Krishna Hare Hare incessantly, without break, day in and day out, all 365 days around the huge lighted lamp. This Japa is still being continued in the Ashrama. The Tampura, Gurudev lifted has not touched earth for the last 70 years. The Japa Podium is a solace to the ailing minds that visit and participate in the Japa here. <br /><br />

In 1973, Akhanda Japa was introduced in Arayoor Ashram also. <br /><br />

Both the Ashrams had modest, humble beginnings. Swamiji was against any patronage from outside agencies. He did not entertain any publicity as well. But with his faith in God and Nama, Swamiji, along with his devotees worked hard to establish the Ashramams without outward propaganda. <br /> <br />

The Ashramam is for the prosperity of humanity and to free it from superstitions, casteism and out moded traditions.
                        </p>
                </div>
                
                
           </div> 
                      
        </div>
        
        
      </div>
    </div>
  );
}

export default Timing;